// extracted by mini-css-extract-plugin
export default {"content":"watchlist_content__ykI9F","watchlistitem":"watchlist_watchlistitem__jzIs0"};